import { navigationDelegate } from '../utilities/navigationDelegate';
import { heightDelegate } from '../utilities/heightDelegate';
import { LayoutManager } from '../utilities/layoutManager';
import EventMg, { EventType } from '../utilities/EventManager';

export default class Layout {
  constructor() {
    this.layout;
    window.addEventListener('load', () => {
      this.onload();
      // console.log('debug', 'Window load');
    });

    //マルチタッチ禁止
    window.addEventListener('touchstart', e => {
      if (e.touches.length >= 2) {
        e.preventDefault();
      }
    });
  }

  onload() {
    //--->ここからレイアウト調整用コード
    //ナビゲーションのイベントをデリゲート
    var _naviDelegate = new navigationDelegate();
    _naviDelegate.init();

    //変更通知
    // eslint-disable-next-line no-unused-vars
    _naviDelegate.observeNavi(function(e, val) {
      //ヘッダー幅をテーブルと合わせる
      //アニメーション完了後に取得
      // setTimeout(function(){
      //   document.querySelector(".sys-splitview-1 .schedulelist__header").style.width = document.querySelector(".sys-splitview-1 .schedulelist__list .table").getBoundingClientRect().width+"px";
      // },100);
    });

    // //監視する高さが変わるクリックイベントを登録
    var _heightDelegate = new heightDelegate();
    _heightDelegate.initEvent([
      '#accordion-toggle',
      '.message .btn-message-close',
      '.sys-search-form-accordion-trigger',
    ]);

    // //レイアウト設定
    this.layout = new LayoutManager();
    this.layout.init();
    this.layout.setNavigationDelegate(_naviDelegate);
    this.layout.setHeightDelegate(_heightDelegate);

    // //幅固定
    this.layout.setWidthUpdateElement(
      '.sys-splitview-1 .main__body',
      'funcnavi1'
    );
    this.layout.setWidthUpdateElement(
      '.sys-splitview-2 .main__body',
      'funcnavi2'
    );

    //高さ変更する要素
    this.layout.setHeightUpdateElement('.sys-splitview-1 .main__body');
    this.layout.setHeightUpdateElement('.sys-splitview-2 .main__body');
    // this.layout.setHeightUpdateElement(".sys-splitview-1 .rail__main");
    // this.layout.setHeightUpdateElement(".sys-splitview-2 .rail__main");
    this.layout.setHeightUpdateElement('.func-navi');
    this.layout.setHeightUpdateElement(
      '.func-navi .list--func-navi .list__scroll'
    );
    this.layout.setHeightUpdateElement('.sys-splitview-1 .main__body');
    this.layout.setHeightUpdateElement('.sys-splitview-2 .main__body');
    this.layout.setHeightUpdateElement('.sys-splitview-1 .setting-main__body');
    this.layout.setHeightUpdateElement('.sys-splitview-2 .setting-main__body');
    //<---ここまでレイアウト調整用コード

    //ピンチイン、アウトを禁止

    // eslint-disable-next-line no-unused-vars
    var _this = this;
    EventMg.addEventListener(EventType.LAYOUT_UPDATE, () => {
      setTimeout(() => {
        _naviDelegate.forceUpdate();
        _heightDelegate.forceUpdate();
      }, 30);
    });

    //強制的にアップデート
    setTimeout(() => {
      _naviDelegate.forceUpdate();
      _heightDelegate.forceUpdate();
      this.layout.forceUpdate();
    }, 1);
  }
}



// WEBPACK FOOTER //
// ./src/utilities/layout.js